import { supabase } from '../services/supabaseClient';

const formatCapacityError = (resource, capacity) => {
  const used = resource === 'sensor' ? capacity?.sensors_used : capacity?.gateways_used;
  const total = resource === 'sensor' ? capacity?.sensor_capacity : capacity?.gateway_capacity;
  if (typeof used === 'number' && typeof total === 'number') {
    return `${resource === 'sensor' ? 'Sensor' : 'Gateway'} limit reached (${used} of ${total}). Add capacity on your subscription or upgrade your plan.`;
  }
  return `${resource === 'sensor' ? 'Sensor' : 'Gateway'} limit reached. Add capacity on your subscription or upgrade your plan.`;
};

export const getSensorRegistrationCapacity = async () => {
  const { data, error } = await supabase.rpc('get_sensor_registration_capacity');
  if (error) {
    throw error;
  }
  return data;
};

export const getGatewayRegistrationCapacity = async () => {
  const { data, error } = await supabase.rpc('get_gateway_registration_capacity');
  if (error) {
    throw error;
  }
  return data;
};

export const assertSensorRegistrationAllowed = async () => {
  const capacity = await getSensorRegistrationCapacity();
  if (!capacity?.allowed) {
    throw new Error(formatCapacityError('sensor', capacity));
  }
  return capacity;
};

export const assertGatewayRegistrationAllowed = async () => {
  const capacity = await getGatewayRegistrationCapacity();
  if (!capacity?.allowed) {
    throw new Error(formatCapacityError('gateway', capacity));
  }
  return capacity;
};

export const mapRegistrationError = (error, resource = 'sensor') => {
  const message = error?.message || '';
  if (message.includes('Sensor limit reached') || message.includes('Gateway limit reached')) {
    return message;
  }
  if (message.includes('Active subscription required')) {
    return 'An active subscription is required before you can register devices.';
  }
  if (message.includes('Authentication required')) {
    return 'You must be signed in to register devices.';
  }
  return message || `Failed to register ${resource}.`;
};
